import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { OverlayParticle } from "@lib/titan2/dist/game/view/display/AbstractOverlay";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { gsap } from "gsap";
import * as PIXI from "pixi.js";
import { FreeSpinOverlayEvent, SlingoEvent } from "../../../controller/event/SlingoEvent";
import { TweenConstants } from "../constant/TweenConstants";
import { SlingoStyle } from "../style/SlingoStyle";
import { Overlay } from "./Overlay";
export class FreeSpinsOverlayParticle extends OverlayParticle {
    constructor() {
        super(...arguments);
        this.easeX = "none";
        this.easeY = "power2.in";
    }
}
/**
 * FreeSpinsOverlay.ts
 */
export class FreeSpinsOverlay extends Overlay {
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "FreeSpinsOverlay");
    }
    createParticles() {
        this.particles = new Dictionary();
        this.uiProperties.particleProperties.map((props, index) => {
            const particle = new FreeSpinsOverlayParticle(this.landscapeProperties.particleProperties[index], this.portraitProperties?.particleProperties[index]);
            particle.holder = new PIXI.Container();
            particle.holder.addChild(particle);
            particle.holder.visible = false;
            this.addChild(particle.holder);
            return particle;
        }).forEach(particle => this.particles.setValue(particle.id, particle));
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.REELS_AWARD, this.handleReelsAward);
        this.registerGame(FreeSpinOverlayEvent.FREE_SPIN_START, this.handleFreeSpinStart);
    }
    handleReelsAward() {
        this.freeSpinIndices = this.model.getSpinResult().getReelSequence().getFreeSpinIndexes();
    }
    handleFreeSpinStart() {
        const next = this.freeSpinIndices.shift();
        const particleId = `${SlingoStyle.REEL}_${next}`;
        this.tweenParticle(particleId);
    }
    handleTweenComplete(particle) {
        particle.holder.visible = false;
        this.dispatchGame(FreeSpinOverlayEvent.FREE_SPIN_END);
    }
    addParticle(particleId) {
        const particle = this.particles.getValue(particleId);
        particle.holder.visible = true;
        return particle;
    }
    tweenParticle(particleId) {
        const particle = this.addParticle(particleId);
        particle.visible = true;
        particle.alpha = 0;
        particle.holder.position.set(particle.source.x, particle.source.y);
        if (particle.entity instanceof TitanSpine) {
            particle.entity.play(SlingoStyle.FREE_SPINS_OVERLAY_ANIMATION, true);
        }
        gsap.timeline()
            .call(() => {
            particle.alpha = TweenConstants.FREE_SPINS_ALPHA;
            this.dispatchGame(SlingoEvent.FREE_SPIN_TWEEN);
        }, [], TweenConstants.FREE_SPINS_INTRO_DURATION)
            .to(particle.holder.position, {
            x: particle.destination.x,
            ease: particle.easeX,
            duration: TweenConstants.FREE_SPINS_FLIGHT_DURATION
        }, TweenConstants.FREE_SPINS_INTRO_DURATION)
            .to(particle.holder.position, {
            y: particle.destination.y,
            ease: particle.easeY,
            duration: TweenConstants.FREE_SPINS_FLIGHT_DURATION
        }, TweenConstants.FREE_SPINS_INTRO_DURATION)
            .call(() => {
            particle.alpha = 1;
            this.handleTweenComplete(particle);
        });
    }
}
//# sourceMappingURL=FreeSpinsOverlay.js.map